import { useContext, useState } from "react";
import { Alert, Button, Col, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Get from "../../api/Get";
import Put from "../../api/Put";
import { APPOINTMENT_UPDATE, GET_CHECKLIST_DOCUMENTS_ADJUNTOS } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";

function SendDocPatient({ t, cita, setShowSuccess, setShowModalServer, setErrorServer }) {
    const [sendingDoc, setSendingDoc] = useState(false)
    const { auth } = useContext(authContext)
    const [modalShow, setModalShow] = useState(false)
    const [documentosEnviar, setDocumentosEnviar] = useState(null)
    const [existDocuments, setExistsDocuments] = useState(true)

    const [sendExpedienteGinecoObstetrico, setSendExpedienteGinecoObstetrico] = useState(false);
    const [sendExpedienteAtencionNinoSano, setSendExpedienteAtencionNinoSano] = useState(false);
    const [sendExpedienteAtencionPeronsalesPatologicos, setSendExpedienteAtencionPeronsalesPatologicos] = useState(false);
    const [sendExpedientePrevencionAccidentes, setSendExpedientePrevencionAccidentes] = useState(false);
    const [sendExpedienteAtencionGerontologica, setSendExpedienteAtencionGerontologica] = useState(false);
    const [sendExpedientePadecimientoActual, setSendExpedientePadecimientoActual] = useState(false);
    const [sendExpedientePromocionSalud, setSendExpedientePromocionSalud] = useState(false);

    const resetCheckboxStates = () => {
        setSendExpedienteGinecoObstetrico(false);
        setSendExpedienteAtencionNinoSano(false);
        setSendExpedienteAtencionPeronsalesPatologicos(false);
        setSendExpedientePrevencionAccidentes(false);
        setSendExpedienteAtencionGerontologica(false);
        setSendExpedientePadecimientoActual(false);
        setSendExpedientePromocionSalud(false);
    }

    const documentosParaEnviar = async () => {
        setModalShow(true);
        setSendingDoc(true)
        setExistsDocuments(true)
        try {
            const response = await Get({ url: `${GET_CHECKLIST_DOCUMENTS_ADJUNTOS}/${cita.id}`, access_token: auth.data.access_token })
            //console.log(response)
            if (response.data.state) {
                setSendingDoc(false)
                setDocumentosEnviar(response.data.data)
                const data = response.data.data
                const isColombia = auth.data.company.id === 2
                const hasAdjuntos = isColombia && Array.isArray(data?.adjuntos) && data.adjuntos.length > 0
                const hasOtherDocs = data && (data.ficha || data.historia || data.receta || data.incapacidad
                    || data.recomendacion || data.remision || data.estudios || data.laboratorio
                    || data.expedienteGinecoObstetrico || data.expedienteAtencionNinoSano
                    || data.expedienteAtencionPeronsalesPatologicos || data.expedientePrevencionAccidentes
                    || data.expedienteAtencionGerontologica || data.expedientePadecimientoActual || data.expedientePromocionSalud)
                if (!hasOtherDocs && !hasAdjuntos) {
                    setExistsDocuments(false)
                }
            } else {
                setSendingDoc(false)
                setDocumentosEnviar(null)
                setExistsDocuments(false)
            }
        } catch (error) {
            setSendingDoc(false)
            setShowModalServer(true)
            setErrorServer(error?.response)
        }
    }
    const handleEnviarDocumentos = e => {
        setSendingDoc(true)
        let dataAppointment = {
            id: cita.id,
            sendMedicalHistory: true,
            sendExpedienteGinecoObstetrico,
            sendExpedienteAtencionNinoSano,
            sendExpedienteAtencionPeronsalesPatologicos,
            sendExpedientePrevencionAccidentes,
            sendExpedienteAtencionGerontologica,
            sendExpedientePadecimientoActual,
            sendExpedientePromocionSalud
        }
        Put({ url: APPOINTMENT_UPDATE, data: dataAppointment, access_token: auth.data.access_token, header: true })
            .then(response => {
                setSendingDoc(false)
                setModalShow(false)
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                }, 2000);
            })
            .catch(error => {
                //console.log("Error al acualizar el envío del historiál clínico", error)
                setSendingDoc(false)
                setModalShow(false)
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
    }

    /*const handleEnviarDocumentos = e => {
        setSendingDoc(true)
        let dataAppointment = {
            id: cita.id,
            sendMedicalHistory: true
        }
        Put({ url: APPOINTMENT_UPDATE, data: dataAppointment, access_token: auth.data.access_token, header: true })
            .then(response => {
                setSendingDoc(false)
                setModalShow(false)
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                }, 2000);
            })
            .catch(error => {
                //console.log("Error al acualizar el envío del historiál clínico", error)
                setSendingDoc(false)
                setModalShow(false)
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
    }*/
    const handleCloseModal = () => {
        setModalShow(false);
        resetCheckboxStates();
    }
    return (
        <Row className="mt-2">
            <Col>
                <label>
                    {t('desea_enviar_documentos')}
                </label>{' '}
                <Button type="button"
                    size="sm"
                    variant="outline-info"
                    onClick={documentosParaEnviar}
                >
                    {t('quiero_enviarlos')}
                </Button>
            </Col>
            <Modal show={modalShow} onHide={handleCloseModal} centered className="border-0">
                {sendingDoc && <SimpleLoad />}
                <Modal.Header>¿Está seguro que desea enviar los siguientes documentos?</Modal.Header>
                <Modal.Body>
                    {
                        !existDocuments &&
                        <Alert variant="info">No existen documentos a enviar</Alert>
                    }
                    <ul>
                        {documentosEnviar?.ficha && <li>Ficha epidemiológica.</li>}
                        {documentosEnviar?.historia && <li>Historia clínica.</li>}
                        {documentosEnviar?.receta && <li>Receta.</li>}
                        {documentosEnviar?.incapacidad && <li>Incapacidad.</li>}
                        {documentosEnviar?.recomendacion && <li>Recomendación médica.</li>}
                        {documentosEnviar?.remision && <li>Remisiones.</li>}
                        {documentosEnviar?.estudios && <li>Estudios imagenológicos.</li>}
                        {documentosEnviar?.laboratorio && <li>Laboratorios.</li>}
                        {documentosEnviar?.expedienteGinecoObstetrico && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedienteGinecoObstetrico} onChange={() => setSendExpedienteGinecoObstetrico(!sendExpedienteGinecoObstetrico)} />
                                    {" "}Ginecoobstétrico.
                                </label>
                            </li>
                        )}
                        {documentosEnviar?.expedienteAtencionNinoSano && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedienteAtencionNinoSano} onChange={() => setSendExpedienteAtencionNinoSano(!sendExpedienteAtencionNinoSano)} />
                                    {" "}Niño Sano.
                                </label>
                            </li>
                        )}
                        {documentosEnviar?.expedienteAtencionPeronsalesPatologicos && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedienteAtencionPeronsalesPatologicos} onChange={() => setSendExpedienteAtencionPeronsalesPatologicos(!sendExpedienteAtencionPeronsalesPatologicos)} />
                                    {" "}Ant. Pers. Patológicos.
                                </label>
                            </li>
                        )}
                        {documentosEnviar?.expedientePrevencionAccidentes && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedientePrevencionAccidentes} onChange={() => setSendExpedientePrevencionAccidentes(!sendExpedientePrevencionAccidentes)} />
                                    {" "}Prevención Accidentes.
                                </label>
                            </li>
                        )}
                        {documentosEnviar?.expedienteAtencionGerontologica && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedienteAtencionGerontologica} onChange={() => setSendExpedienteAtencionGerontologica(!sendExpedienteAtencionGerontologica)} />
                                    {" "}Gerintológico.
                                </label>
                            </li>
                        )}
                        {documentosEnviar?.expedientePadecimientoActual && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedientePadecimientoActual} onChange={() => setSendExpedientePadecimientoActual(!sendExpedientePadecimientoActual)} />
                                    {" "}Padecimiento actual.
                                </label>
                            </li>
                        )}
                        {documentosEnviar?.expedientePromocionSalud && (
                            <li>
                                <label>
                                    <input type="checkbox" checked={sendExpedientePromocionSalud} onChange={() => setSendExpedientePromocionSalud(!sendExpedientePromocionSalud)} />
                                    {" "}Promoción de la salud.
                                </label>
                            </li>
                        )}
                        {auth.data.company.id === 2 && Array.isArray(documentosEnviar?.adjuntos) && documentosEnviar.adjuntos.map((item, index) => (
                            <li key={item.id ?? `adjunto-${index}`}>{item.filename || `Adjunto ${item.id ?? index}`}</li>
                        ))}
                    </ul>

                    <Row>
                        <Col className="text-right">
                            <Button
                                variant="secondary"
                                className="btn1"
                                onClick={handleCloseModal}
                            >Cancelar</Button>{' '}
                            <Button
                                variant="primary"
                                className="btn1"
                                onClick={handleEnviarDocumentos}
                                disabled={!existDocuments}
                            >Enviar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </Row>
    )
}

export default withTranslation()(SendDocPatient)